import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthApiService } from './core/service/auth-api.service';
import { AppConstant } from './helper/class/app-constant';
import { isEmptyObj } from './helper/class/utilityHelper';
import { ResponseData } from './helper/interface/response';
import { AlertService } from './helper/service/alert.service';
import { AuthService } from './helper/service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent implements OnInit {
  title = AppConstant.TITLE;
  loading: boolean = false;
  settingData: any;

  constructor(private alertService: AlertService, private router: Router, private titleServ: Title,
    protected activeRoute: ActivatedRoute,
    private auth: AuthService, private authApi: AuthApiService,
  ) {
    this.titleServ.setTitle(this.title);
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (event instanceof NavigationEnd) {
        this.loading = false;
        console.log("event end")
      }
    });
  }
  ngOnInit(): void {
    this.getSetting();
  }

  // setThemeColor(color){
  //   const r = document.documentElement;
  //   r.style.setProperty('--theme-bg',color);
  //   console.log('color changes',color)
  // }

  setThemeColor(primaryColor: string) {
    const primaryRgb = this.hexToRgb(primaryColor);
    const adjustedSecondaryRgb = {
      r: primaryRgb.r + 20,
      g: primaryRgb.g + 20,
      b: primaryRgb.b + 20
    };
    const secondaryRgb = {
      r: Math.min(255, adjustedSecondaryRgb.r),
      g: Math.min(255, adjustedSecondaryRgb.g),
      b: Math.min(255, adjustedSecondaryRgb.b)
    };
    const secondaryColor = this.rgbToHex(secondaryRgb.r, secondaryRgb.g, secondaryRgb.b);
    this.setGradientColors(primaryColor, secondaryColor);
  }


  setGradientColors(primaryColor: string, secondaryColor: string) {
    const r = document.documentElement;
    r.style.setProperty('--theme-bg', primaryColor);
    r.style.setProperty('--gradient-color2', secondaryColor);
    console.log('gradient colors changed', primaryColor, secondaryColor);
  }

  hexToRgb(hex: string) {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255
    };
  }

  rgbToHex(r: number, g: number, b: number) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  getSetting() {
    const s = this.auth.currentSettingValue;
    if (isEmptyObj(s)) {
      this.authApi.getSetting().then((res: ResponseData) => {
        this.setThemeColor(res.result.theme_color ?? '#A00000')
        this.setAppFavicon(res.result.logo_path)
      })
    } else if (s.logo_path) {
      this.setThemeColor(s.theme_color ?? '#A00000')
      this.setAppFavicon(s.logo_path)
    }
  }
  setAppFavicon(urlPath: string) {
    const favIcon: any = document.getElementById('appIcon');
    favIcon?.setAttribute('href', urlPath);
  }
  onclick() {
    this.alertService.clearToast();
  }
}